import gsap from 'gsap';

window.addEventListener('load', () => {
    const videos = document.querySelectorAll<HTMLElement>('.highlighted-product-component .product-video');

    videos.forEach(video => {
        const thumbnail = video.querySelector<HTMLButtonElement>('.product-video__thumbnail') as HTMLElement;
        const iframe = video.querySelector<HTMLIFrameElement>('iframe') as HTMLIFrameElement;

        const playVideo = () => {
            const srcAttr = iframe.getAttribute('fake-src') || iframe.src;
            if (!srcAttr) return;
            const url = new URL(srcAttr);
            url.searchParams.set('autoplay', '1');
            url.searchParams.set('mute', '0');
            iframe.src = url.toString();
            thumbnail.removeEventListener('click', playVideo);

            setTimeout(() => {
                gsap.to(thumbnail, {opacity: 0, duration: 0.2});
            }, 200);

            setTimeout(() => {
                thumbnail.remove();
            }, 400);
        }

        thumbnail.addEventListener('click', playVideo)
    })
})